const ZONE_LABELS: Record<string, string> = {
  'Asia/Manila': 'PHT',
  'Asia/Singapore': 'SGT',
  'Asia/Bangkok': 'ICT',
  'Asia/Ho_Chi_Minh': 'ICT',
  'Asia/Jakarta': 'WIB',
};

const isKnownZone = (zone: string) => {
  try {
    new Intl.DateTimeFormat('en-GB', { timeZone: zone });
    return true;
  } catch {
    return false;
  }
};

/** The farm's own zone when it is a real one; otherwise the browser's, so a bad setting never throws. */
function effectiveZone(farmZone: string | null | undefined): string {
  return farmZone && isKnownZone(farmZone) ? farmZone : new Intl.DateTimeFormat().resolvedOptions().timeZone;
}

/** "Mon 19 Oct 2026", "5:22 PM" and the zone label ("PHT", or Intl's "GMT+5:30" for a zone not in the lookup), all in the farm's zone. */
export function farmStamp(instant: Date, farmZone: string | null | undefined): { date: string; time: string; label: string } {
  const timeZone = effectiveZone(farmZone);
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone,
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    timeZoneName: 'short',
  }).formatToParts(instant);
  const get = (type: string) => parts.find((p) => p.type === type)?.value ?? '';
  return {
    date: `${get('weekday')} ${get('day')} ${get('month')} ${get('year')}`,
    time: `${get('hour')}:${get('minute')} ${get('dayPeriod')}`,
    label: ZONE_LABELS[timeZone] ?? get('timeZoneName'),
  };
}
